import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNoteSticky } from "@fortawesome/free-solid-svg-icons";
import Avatar from "../../../../components/Avatar";
import { useVisible } from "../../../../utils/hooks/useVisible";
import { useCompanyDateFormat, useCompanyTimeFormat } from "../../../../utils/hooks/company";
import { renderUserName } from "../../../../utils/helpers/user";
import "./style.scss";

const getColor = (status) => {
    let color;
    switch (status) {
        case "pending": {
            color = "orange";
            break;
        }
        case "approved": {
            color = "green";
            break;
        }
        case "rejected": {
            color = "red";
            break;
        }
        case "applied": {
            color = "darkblue";
            break;
        }
        default:
            break;
    }
    return color;
}

const StatusCell = ({ original }) => {
    const { t } = useTranslation();
    const id = `retro-${original?.id}`;
    const { visible, toggle } = useVisible();
    const dateFormat = useCompanyDateFormat();
    const timeFormat = useCompanyTimeFormat();

    return (
        <>
            <span
                className="px-3 py-2 rounded"
                style={{
                    border: `1px solid ${getColor(original.status)}`,
                    color: getColor(original.status),
                    borderRadius: "20px",
                }}
            >
                {t(original.status)}
            </span>

            {original?.logs?.length > 0 && (
                <>
                    <span id={id}>
                        <FontAwesomeIcon
                            className="cursor-pointer text-primary mx-2"
                            icon={faNoteSticky}
                        />
                    </span>

                    <Tooltip
                        target={id}
                        isOpen={visible}
                        toggle={toggle}
                        className="retro-reason-tooltip"
                        autohide={false}
                        placement="auto-end"
                    >
                        <div className="d-flex flex-column">
                            {original.logs.map((item) => {
                                return (
                                    <div className="p-3 item rounded d-flex gap-3 align-items-center mb-1">
                                        <Avatar
                                            user={item.user}
                                            txtStyle={{ fontSize: "18px" }}
                                        />

                                        <div className="d-flex flex-column gap-2">
                                            {item?.user && (
                                                <div className="d-flex gap-2 align-items-center">
                                                    <span className="font-weight-bold">
                                                        {t("user")}:
                                                    </span>
                                                    <span>{renderUserName(item.user)}</span>
                                                </div>
                                            )}
                                            {item?.date && (
                                                <div className="d-flex gap-2 align-items-center">
                                                    <span className="font-weight-bold">
                                                        {t("date")}:
                                                    </span>

                                                    <span>{moment.parseZone(item?.date).format(`${dateFormat}  ${timeFormat}`)}</span>
                                                </div>
                                            )}
                                            {item?.status && (
                                                <div className="d-flex gap-2 align-items-center">
                                                    <span className="font-weight-bold">
                                                        {t("status")}:
                                                    </span>

                                                    <span
                                                        className="text-center px-3 py-1"
                                                        style={{
                                                            border: `1px solid ${getColor(item.status)}`,
                                                            color: getColor(item.status),
                                                            borderRadius: "20px",
                                                        }}
                                                    >
                                                        {t(item.status)}
                                                    </span>
                                                </div>
                                            )}
                                            {item?.reason && (
                                                <div className="d-flex gap-2 align-items-center">
                                                    <span className="font-weight-bold">
                                                        {t("reason")}:
                                                    </span>

                                                    <span>{item.reason}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </Tooltip>
                </>
            )}
        </>
    );
}

export default StatusCell;
